import { Field, InputType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { FilterQuery } from '../../repository/types'
import type { Order } from '../Order'

export interface IUpdateOrder extends IAction<Order, UpdateOrderArgs> {}

/**
 * Args for the generic updateOrder path. Mirrors BaseResolver's CRUD contract (an arbitrary partial
 * `input` plus a `filter`); the resolver keeps its explicit JSON `input`/`filter` args.
 */
@InputType()
export class UpdateOrderArgs extends ActionArgs {
  /** The fields to change on the order. */
  @Field(() => GraphQLJSON, { nullable: false })
  input: Partial<Order>

  /** Names the order; the Action pins the write to its `_id`. */
  @Field(() => GraphQLJSON, { nullable: true })
  filter?: FilterQuery<Order>
}
